import React from 'react';
import Card from 'react-bootstrap/Card';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import classes from './ContactCard.module.scss';

import ASH from '../../assets/facility-images/ASH.png';
import defaultImage from '../../assets/facility-images/ashford.png';
import BAR from '../../assets/facility-images/BAR.png';
import GEP from '../../assets/facility-images/GEP.png';
import LON from '../../assets/facility-images/LON.png';
import MEL from '../../assets/facility-images/MEL.png';
import NOR from '../../assets/facility-images/NOR.png';
import PAR from '../../assets/facility-images/PAR.png';
import { ReactComponent as IconEmail } from '../../assets/icon-email.svg';
import { ReactComponent as IconPhone } from '../../assets/icon-phone.svg';

interface Props {
    location: Location;
}

function ContactCard({ location }: Props) {
    const image =
        {
            ASH: ASH,
            BAR: BAR,
            GEP: GEP,
            LON: LON,
            MEL: MEL,
            NOR: NOR,
            PAR: PAR,
        }[location.locationCode] ?? defaultImage;

    const addressLine = [location.address.address1, location.address.address2]
        .filter(Boolean)
        .join(' ');
    return (
        <Card className={`h-100 ${classes.card}`}>
            <Card.Img src={image} variant={'top'}></Card.Img>
            <Card.Body className={'d-flex flex-column'}>
                <span>Storage {location?.name}</span>
                <span className={'opacity-50 mb-2 mb-lg-3'}>
                    {addressLine}, {location.address.city} {location.address.region}
                </span>
                <div
                    className={`d-flex align-items-center mb-2 mt-lg-auto mb-lg-4 ${classes.phone}`}
                >
                    <IconPhone className={'text-primary'} />
                    <span>{location.contactPhone}</span>
                </div>
                <div className={'d-flex align-items-center'}>
                    <IconEmail
                        className={`me-2 me-lg-3 opacity-40 ${classes.secondaryIcon}`}
                    />
                    <a
                        href={`mailto:${location.contactEmail}`}
                        className={'link transparent'}
                    >
                        Email us
                    </a>

                    {/*
          <IconChat
            className={`ms-4 ms-lg-auto me-2 me-lg-3 opacity-40 ${classes.secondaryIcon}`}
          />
          <a href={"#"} className={"link transparent"}>
            Chat
          </a>
          */}
                </div>
            </Card.Body>
        </Card>
    );
}

export default ContactCard;
